import { Grid, Typography, Paper, Tooltip, Chip, Divider, Button, Link, Box } from '@mui/material';
import Pod1Img from '../../../../assets/HomePage/Pod1Img.png';
import { createPopup } from '@typeform/embed';
import '@typeform/embed/build/css/popup.css';

const { toggle } = createPopup('GPAg2BTo');

const Pods = (props) => {
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={4}>
          <Paper
            elevation={20}
            sx={{
              mt: { xs: '2rem', md: '4rem' },
              textAlign: 'center',
            }}>
            <Box sx={{ padding: { xs: '1rem', md: '2rem' } }}>
              <Tooltip title='A niche group of 100 founders'>
                <Chip label='100Pod' color='primary' />
              </Tooltip>
              <Typography variant='h6' sx={{ fontWeight: 'bold', my: '1rem' }}>
                The Early Adopters (Free)
              </Typography>
              <img src={Pod1Img} alt='' style={{ maxWidth: '50%', height: 'auto' }} />
              <Typography variant='body1' sx={{ mt: '1rem' }}>
                85 / 100 Members
              </Typography>
              <Divider variant='middle' sx={{ my: '1rem' }} />
              <Typography variant='body1' sx={{ my: '1.2rem' }}>
                For those who want to take a chance on us and help us develop + test new concepts in The 100 Club. We
                welcome founders from all backgrounds to join us here.
              </Typography>
              <Link
                key={1}
                onClick={toggle}
                sx={{
                  textDecoration: 'none',
                }}>
                <Button variant='contained' sx={{ mt: '1rem' }}>
                  Join Today
                </Button>
              </Link>
              <Tooltip
                title={
                  <span>
                    <p>• No requirements besides being a founder</p>
                    <p>• Early stage adopter</p>
                    <p>• Open mindset</p>
                  </span>
                }>
                <Typography
                  variant='body1'
                  sx={{
                    mt: '0.5rem',
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                    fontSize: '0.8rem',
                  }}>
                  Member Criteria
                </Typography>
              </Tooltip>
            </Box>
            <Typography
              variant='body1'
              sx={{
                p: '0.5rem',
                fontWeight: 'bold',
                fontSize: '0.8rem',
                color: 'white',
                backgroundColor: 'primary.main',
              }}>
              Singapore Only
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Paper
            elevation={20}
            sx={{
              mt: { xs: '2rem', md: '4rem' },
              textAlign: 'center',
            }}>
            <Box sx={{ padding: { xs: '1rem', md: '2rem' } }}>
              <Tooltip title='A niche group of 100 founders'>
                <Chip label='100Pod' color='primary' />
              </Tooltip>
              <Typography variant='h6' sx={{ fontWeight: 'bold', my: '1rem' }}>
                eCommerce Founders
              </Typography>
              <img src={Pod1Img} alt='' style={{ maxWidth: '50%', height: 'auto' }} />
              <Typography variant='body1' sx={{ mt: '1rem' }}>
                22 / 100 Members
              </Typography>
              <Divider variant='middle' sx={{ my: '1rem' }} />
              <Typography variant='body1' sx={{ my: '1.2rem' }}>
                Get connected with eCommerce business owners who run 7-figure stores. Learn the latest marketing trends
                and methods to scale to 8-figures and beyond.
              </Typography>
              <Link
                key={1}
                onClick={toggle}
                sx={{
                  textDecoration: 'none',
                }}>
                <Button variant='contained' sx={{ mt: '1rem' }}>
                  Join Today
                </Button>
              </Link>
              <Tooltip
                title={
                  <span>
                    <p>• eCommerce Founders</p>
                    <p>• Actively Running</p>
                    <p>• Total Revenue to Date {'>'}$1M</p>
                    <p>• Willing to actively contribute to the community</p>
                  </span>
                }>
                <Typography
                  variant='body1'
                  sx={{
                    mt: '0.5rem',
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                    fontSize: '0.8rem',
                  }}>
                  Member Criteria
                </Typography>
              </Tooltip>
            </Box>
            <Typography
              variant='body1'
              sx={{
                p: '0.5rem',
                fontWeight: 'bold',
                fontSize: '0.8rem',
                color: 'white',
                backgroundColor: 'primary.main',
              }}>
              Singapore Only
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Paper
            elevation={20}
            sx={{
              mt: { xs: '2rem', md: '4rem' },
              textAlign: 'center',
            }}>
            <Box sx={{ padding: { xs: '1rem', md: '2rem' } }}>
              <Tooltip title='A niche group of 100 founders'>
                <Chip label='100Pod' color='primary' />
              </Tooltip>
              <Typography variant='h6' sx={{ fontWeight: 'bold', my: '1rem' }}>
                SaaS Founders
              </Typography>
              <img src={Pod1Img} alt='' style={{ maxWidth: '50%', height: 'auto' }} />
              <Typography variant='body1' sx={{ mt: '1rem' }}>
                16 / 100 Members
              </Typography>
              <Divider variant='middle' sx={{ my: '1rem' }} />
              <Typography variant='body1' sx={{ my: '1.2rem' }}>
                Get connected with SaaS founders who have run software companies with {'>'}$10k MRR. Stay supported
                throughout your journey as you work towards $100k MRR.
              </Typography>
              <Link
                key={1}
                onClick={toggle}
                sx={{
                  textDecoration: 'none',
                }}>
                <Button variant='contained' sx={{ mt: '1rem' }}>
                  Join Today
                </Button>
              </Link>
              <Tooltip
                title={
                  <span>
                    <p>• SaaS Founders</p>
                    <p>• Actively Running</p>
                    <p>• {'>'}$10K MRR</p>
                    <p>• Willing to actively contribute to the community</p>
                  </span>
                }>
                <Typography
                  variant='body1'
                  sx={{
                    mt: '0.5rem',
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                    fontSize: '0.8rem',
                  }}>
                  Member Criteria
                </Typography>
              </Tooltip>
            </Box>
            <Typography
              variant='body1'
              sx={{
                p: '0.5rem',
                fontWeight: 'bold',
                fontSize: '0.8rem',
                color: 'white',
                backgroundColor: 'primary.main',
              }}>
              Singapore Only
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <Link
        onClick={toggle}
        style={{
          width: '100%',
          textDecoration: 'none',
          cursor: 'pointer',
        }}>
        <Paper
          elevation={20}
          sx={{
            p: '2px 4px',
            mt: '2rem',
            width: '100%',
            backgroundColor: 'primary.main',
          }}>
          <Typography
            sx={{
              ml: 1,
              p: '10px',
              color: 'white',
            }}>
            Can't find a 100Pod that fits your niche? Let us know in your application and we'll set one up for you.
          </Typography>
        </Paper>
      </Link>
    </Box>
  );
};

export default Pods;
